import {reqNavbarList} from "@/api";

const state = {
    navbarList: [],
    routesList: []
};
const mutations = {
    NAVBARLIST(state, navbarList) {
        state.navbarList = navbarList
    },
    ROUTESLIST(state, routesList) {
        state.routesList = routesList
    }
};
const actions = {
    //通过API里面的接口函数调用，向服务器发送请求获取数据
    async getNavbarList({commit}) {
        let result = await reqNavbarList();
        if(result.code === 0) {
            let res = result.data
            // console.log('res', res)
            let routesList = [], navbarList = []
            for(let menu of res) {
                let {url, componentPath, name, meta, children} = menu
                routesList.push({
                    url, componentPath, name, meta
                })
                navbarList.push({
                    url, componentPath, name, meta, children
                })
                /*if(menu.children.length > 0) {
                    for(let submenu of menu.children) {
                        let {url, componentPath, name, meta} = submenu
                        routesList.push({
                            url, componentPath, name, meta
                        })
                    }
                }*/
            }
            let temp = null, tempI = 0;
            for(let i=0; i<navbarList.length; i++) {
                if(navbarList[i].name == 'chanyeyanjiu') {
                    temp = navbarList[i]
                    tempI = i
                    break
                }
            }
            if(temp !== null) {
                navbarList.splice(tempI, 1)
                navbarList.splice(4, 0, temp)
            }
            let temp2 = null, temp2I = 0;
            for(let i=0; i<routesList.length; i++) {
                if(routesList[i].name == 'chanyeyanjiu') {
                    temp2 = routesList[i]
                    temp2I = i
                    break
                }
            }
            if(temp2 !== null) {
                routesList.splice(temp2I, 1)
                routesList.splice(4, 0, temp2)
            }
            // console.log('routesList', routesList)
            // console.log('navbarList',navbarList)
            commit('NAVBARLIST', navbarList)
            commit('ROUTESLIST', routesList)
        }

        /*console.log(result)
        console.log(routesList)*/

    }
};
const getters = {};

export default {
    state,
    mutations,
    actions,
    getters
}
